import { render } from "./Wishlist.vue?vue&type=template&id=1e4e0146&scoped=true"
import script from "./Wishlist.vue?vue&type=script&lang=js"
export * from "./Wishlist.vue?vue&type=script&lang=js"

import "@/assets/scss/_wishlist.scss?vue&type=style&index=0&id=1e4e0146&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e4e0146"]])

export default __exports__